import { useTranslation } from "react-i18next";
import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "wouter";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen w-full flex items-center justify-center">
      <div className="glass-page-bg" />
      <div className="glass-panel depth-shadow-lg w-full max-w-md mx-4 p-10 text-center">
        <div className="empty-state-icon mx-auto mb-6">
          <Compass className="h-14 w-14 text-primary/40" />
        </div>
        <h1 className="text-2xl font-bold glow-text-sm" data-testid="text-not-found-title">{t("common.notFound")}</h1>
        <p className="mt-3 text-sm text-muted-foreground/70 leading-relaxed">
          {t("common.notFoundDesc")}
        </p>
        <div className="divider-glow my-6" />
        <Link href="/">
          <Button className="btn-gradient-capsule px-6" data-testid="button-go-home">
            {t("common.backToHome", { defaultValue: "Back to Home" })}
          </Button>
        </Link>
      </div>
    </div>
  );
}
